import { useQuery } from '@src/shared/query';
import type { HolidayDate, HolidayDateDto } from '../../types';
import { holidaysUrl } from './constants';

function selectHolidays(data: HolidayDateDto[]): HolidayDate[] {
  return data.map((dto) => ({
    date: dto.date,
    branchId: dto.branch_id,
    days: Number.parseFloat(dto.days),
    name: dto.name,
    branchName: dto.branch_name,
  }));
}

export type HolidayQueryParams = Partial<{
  date_from: string;
  date_to: string;
}>;

export function getHolidayYearQueryParams(
  anchorDate: Date = new Date(),
): HolidayQueryParams {
  const year = anchorDate.getFullYear();
  return {
    date_from: `${year}-01-01`,
    date_to: `${year}-12-31`,
  };
}

export function getHolidayRangeQueryParams(range: {
  start: Date;
  end: Date;
}): HolidayQueryParams {
  return {
    date_from: `${range.start.getFullYear()}-01-01`,
    date_to: `${range.end.getFullYear()}-12-31`,
  };
}

export default function useHolidays(queryParams: HolidayQueryParams = {}) {
  const effectiveQueryParams =
    Object.keys(queryParams).length > 0
      ? queryParams
      : getHolidayYearQueryParams();

  const { data: holidays = [], ...restQuery } = useQuery<
    HolidayDateDto[],
    HolidayDate[]
  >(holidaysUrl, {
    queryParams: effectiveQueryParams,
    select: selectHolidays,
    initialData: [],
    placeholderData: (previousData) => previousData,
  });

  return {
    holidays,
    ...restQuery,
  };
}
